import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-order-module',
  templateUrl: './order-module.component.html',
  styleUrls: ['./order-module.component.scss'],
})
export class OrderModuleComponent implements OnInit {
  @Input() mode: string = 'content';
  
  showStatusOrders: string = 'new';
  showDeliveryOrders: string = 'delivery';
  showDatetime: string = '';
  
  showHiddeInfoOrders: number = 0;

  showHinweis: boolean = false;
  showThisHinweis: number = 0;

  toolTip: string = '';
  tabsOrder: string = 'new';
  selectClick: string = '';
  statusText: string = '';
  selectText: any = {
    null: 'Status',
    new: 'Neu',
    approved: 'Freigegeben',
    process: 'Im Gange',
    finished: 'Abgeschlossen',
    return: 'Retoure',
    canceled: 'Storniert',
  };
  textDeliver: any = {
    pickup: 'Abholung',
    totable: 'Zu Tisch',
    delivery: 'Lieferung',
    shipment: 'Versand',
  }

  constructor() { }

  ngOnInit() {}


  toggleOrderInfo(showHiddeInfoOrders) {
    if(this.showHiddeInfoOrders === 0) {
      this.showHiddeInfoOrders = showHiddeInfoOrders;
    } else {
      this.showHiddeInfoOrders = 0
    }
  }
  toggleHinweis(showThisHinweis) {
    if(this.showThisHinweis === 0) {
      this.showThisHinweis = showThisHinweis;
    } else {
      this.showThisHinweis = 0
    }
  }
  toggleSelect(selectClick) {
    if(this.selectClick === '') {
      this.selectClick = selectClick
    } else {
      this.selectClick = ''
    }
  }
}
